import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";

const CompanyFormationCTA = () => {
  return (
    <section className="py-16 px-4 bg-section">
      <div className="max-w-4xl mx-auto">
        <Card className="border-none shadow-xl">
          <CardContent className="p-8 md:p-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              Ready to Start Your Business?
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Join thousands of entrepreneurs who have successfully launched their businesses with our expert formation services. 
              Get started today and turn your business idea into reality.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Button size="lg" className="text-lg px-8 py-3">
                Form Your Business
              </Button>
              <Button size="lg" variant="outline" className="text-lg px-8 py-3">
                Compare Packages
              </Button>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted-foreground">
              <span className="flex items-center gap-2">
                ✓ Free business name search
              </span>
              <span className="flex items-center gap-2">
                ✓ Expert entity selection advice
              </span>
              <span className="flex items-center gap-2">
                ✓ 100% satisfaction guarantee
              </span>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default CompanyFormationCTA;